'use client';

import { Alert01Icon } from '@terra/ui-icons';
import { Alert } from '../../../components/alert';

export type InventoryLoadFailedAlertProps = {
  message: string;
};

export function InventoryLoadFailedAlert({
  message,
}: InventoryLoadFailedAlertProps) {
  return (
    <Alert.Root bg="bg.neutral.error">
      <Alert.Icon asChild>
        <Alert01Icon size={16} />
      </Alert.Icon>
      <Alert.Content>
        <Alert.Description>{message}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  );
}
